import config from "../config";

/** Backend origin without `/api/v1` — used for `/horizon`, `/super-admin/*`, etc. */
export const resolveServerRoot = (): string => {
  const apiUrl = config.api.API_URL.replace(/\/+$/, "");

  if (apiUrl.endsWith("/api/v1")) {
    return apiUrl.slice(0, -"/api/v1".length);
  }

  return apiUrl;
};
